module.exports = __webpack_public_path__ + "f7e086665b068ab5f828da8833eb60ff.pdf";